<template>
  <v-app>
    <app-header></app-header>
    <v-main>
      <v-container v-if="isDisplayTypeMap" fluid class="py-0">
        <device-map
          @openDevicePictureDialog="openDevicePictureDialog"
        ></device-map>
        <notification-icon-list></notification-icon-list>
        <p class="caption">
          通知を受けたいセンサのアイコンをタップし、通知オンにしてください。通知を受ける必要が無いものは通知オフにしてください。
        </p>
        <user-device-list></user-device-list>
        <DevicePictureViewDialog
          :dialog="isOpenDevicePictureDialog"
          @close="close"
        />
      </v-container>
      <v-container v-if="isDisplayTypeList" fluid class="py-0">
        <device-list></device-list>
        <device-list-information></device-list-information>
      </v-container>
    </v-main>

    <app-footer></app-footer>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getDevices } from '@/api'
import AppHeader from '@/components/app-header'
import AppFooter from '@/components/app-footer'
import NotificationIconList from '@/components/notification-icon-list'
import DeviceMap from '@/components/device-map'
import UserDeviceList from '@/components/user-device-list'
import DeviceList from '@/components/device-list'
import DeviceListInformation from '@/components/device-list-information'
import { DISPLAY_TYPE_MAP, DISPLAY_TYPE_LIST } from '@/constants'
import DevicePictureViewDialog from '@/components/device-picture-view-dialog'

export default {
  name: 'HomeIndex',
  components: {
    AppHeader,
    AppFooter,
    NotificationIconList,
    DeviceMap,
    UserDeviceList,
    DeviceList,
    DeviceListInformation,
    DevicePictureViewDialog
  },
  data() {
    return {
      isOpenDevicePictureDialog: false
    }
  },
  computed: {
    ...mapGetters(['provider']),
    isDisplayTypeMap() {
      return this.provider.displayType === DISPLAY_TYPE_MAP
    },
    isDisplayTypeList() {
      return this.provider.displayType === DISPLAY_TYPE_LIST
    }
  },
  created() {
    this.initDevices()
  },
  methods: {
    ...mapActions(['setDevices', 'setInfoDeviceId']),
    async initDevices() {
      let res
      try {
        res = await getDevices(this.$route.params.provider)
      } catch (e) {
        console.error(e)
        alert('サーバエラーが発生しました。ログイン画面に遷移します。')
        this.$router.push('/auth/sign-out')
        return
      }
      this.setDevices(res.devices)
      if (this.isDisplayTypeList) {
        this.checkDeviceIdQuery(res.devices)
      }
    },
    checkDeviceIdQuery(devices) {
      if (this.$route.query.device_id === undefined) {
        return
      }
      const found = devices.findIndex(d => d.id === this.$route.query.device_id)
      if (found !== -1) {
        this.setInfoDeviceId(this.$route.query.device_id)
      }
    },
    openDevicePictureDialog() {
      this.isOpenDevicePictureDialog = true
    },
    close() {
      this.isOpenDevicePictureDialog = false
    }
  }
}
</script>

<style scoped>
>>> .v-messages {
  min-height: 0 !important;
}
</style>
